











































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

type ThumbState = 'idle' | 'done-img' | 'done-pdf' | 'error';

const IMAGE_EXTS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'];
const PDF_FRAME_W = 800;
const PDF_FRAME_H = 1131; // A4 at 800 px wide
const ZOOM_FACTOR = 1.6;  // 20% extra zoom

@Component({})
export default class PdfThumbnail extends Vue {
    @Prop({ required: true }) url!: string;
    @Prop({ required: true }) extension!: string;
    @Prop({ default: 'fas fa-file-alt' }) fallbackIcon!: string;
    @Prop({ default: 'default' }) colorClass!: string;
    @Prop({ default: 0 }) delay!: number;

    state: ThumbState = 'idle';
    iframeScale: number = 0.2;
    iframeLeft: number = 0;
    iframeLoaded: boolean = false;
    private observer: IntersectionObserver | null = null;
    private delayTimer: any = null;

    get pdfSrc(): string {
        return `${this.url}#toolbar=0&navpanes=0&scrollbar=0&page=1`;
    }

    get pdfFrameStyle(): object {
        return {
            width: `${PDF_FRAME_W}px`,
            height: `${PDF_FRAME_H}px`,
            transform: `scale(${this.iframeScale})`,
            transformOrigin: 'top left',
            left: `${this.iframeLeft}px`,
        };
    }

    @Watch('url')
    onUrlChange() {
        this.iframeLoaded = false;
        this.state = 'idle';
        this.setupObserver();
    }

    mounted() {
        if (this.delay > 0) {
            this.delayTimer = setTimeout(() => this.setupObserver(), this.delay);
        } else {
            this.setupObserver();
        }
    }

    beforeDestroy() {
        if (this.observer) this.observer.disconnect();
        if (this.delayTimer) clearTimeout(this.delayTimer);
    }

    private setupObserver() {
        if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(
                (entries) => {
                    if (entries[0].isIntersecting && this.state === 'idle') {
                        this.loadThumbnail();
                        if (this.observer) this.observer.disconnect();
                    }
                },
                { rootMargin: '120px' }
            );
            const root = this.$refs.root as Element;
            if (root) this.observer.observe(root);
        } else {
            this.loadThumbnail();
        }
    }

    loadThumbnail() {
        const ext = this.extension.toLowerCase();
        if (IMAGE_EXTS.includes(ext)) {
            this.state = 'done-img';
        } else if (ext === 'pdf') {
            const root = this.$refs.root as HTMLElement;
            const w = (root && root.clientWidth) || 160;
            const scale = (w / PDF_FRAME_W) * ZOOM_FACTOR;
            const scaledW = PDF_FRAME_W * scale;
            this.iframeScale = scale;
            // Center the zoomed content horizontally
            this.iframeLeft = -(scaledW - w) / 2;
            this.state = 'done-pdf';
        } else {
            this.state = 'error';
        }
    }
}
